import useSWR from 'swr';

import { fetcher } from './utils';

export interface ITransactionType {
  transaction_types: string[];
}

export const useTransactionTypeList = () => {
  const url = `/v4/dash/transaction_types`;

  const { data, isLoading, error } = useSWR<ITransactionType>({ url }, fetcher);

  return { data: data?.transaction_types, isLoading, error };
};
